// @flow

import React from 'react'
import { styles as s } from './style'
import './loader.css'

export default function Loader (): React.Element<any> {
  return (
    <div style={s.loaderWrapper}>
      <span className='order-flow-checkout-loader'>
        <div className='checkout-loader--dot' />
        <div className='checkout-loader--dot' />
        <div className='checkout-loader--dot' />
      </span>
    </div>
  )
}
